import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {GENERAL_SETTINGS_COMPONENT} from '../../SettingsUtility';
import {Store} from '@ngrx/store';
import * as settings from 'src/app/store/settings';
import {MinifyNavigationService} from '../../../../../core/minify-navigation/minify-navigation.service';

@Component({
    selector: 'smart-general-setting-component',
    templateUrl: './general-setting.component.html',
    styleUrls: ['./general-setting.component.css']
})
export class GeneralSettingComponent implements OnInit {
    vm$ = this.store.select(settings.selectSettingsState);
    mainSystemColor = 'Purple';
    color = 'info';
    @Output() eventEmitter = new EventEmitter<string>();

    constructor(private store: Store<any>, private minifyNavigationService: MinifyNavigationService) {
    }

    ngOnInit() {
    }

    onClickBackButton() {
        this.eventEmitter.emit(GENERAL_SETTINGS_COMPONENT.name);
    }

    setGlobalFontSize(size: string) {
        this.store.dispatch(settings.setGlobalFontSize({size}));
    }

    changeMainNavigationState() {
        this.minifyNavigationService.changeMinifyState();

    }

    setMainSystemColor(color: string) {
        this.mainSystemColor = color;
    }

    getNavigationState() {
        return this.minifyNavigationService.isMinify();
    }

    setColor(color: string) {
        this.color = color;
    }
}
